import ProfileDropdown from "modules/navbar/top/ProfileDropdown";
import AppContext from "context/Context";
import React, { useContext, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { currentUser, DOCTOR_BOOKING_FLAG, getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";
import ProductDetails from "./ProductDetails";
import CreateTicketScreen from 'modules/CreateTicket/CreateTicketScreen';
import { useCustomer } from 'modules/dashboards/actionables/store';
import _ from 'lodash';
import AppsMenu from "modules/navbar/top/AppsMenu";

const TopNavRightSideNavItem = () => {
  const { customerData } = useCustomer();
  const [isLeadDeatilsPage, setIsLeadDetailsPage] = useState(false)
  useEffect(()=>{
    const pathName = window.location.pathname;
    const pathArray = pathName.split('/');
    setIsLeadDetailsPage(_.get(pathArray,1) === 'lead-details');
  },[window.location.pathname]);
  const {
    config: { isDark },
    setConfig,
  } = useContext(AppContext);
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Nav.Item as={"li"}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          // onClick={() => setConfig("isDark", !isDark)}
        >
          {/* <OverlayTrigger
            key="left"
            placement={"left"}
            overlay={
              <Tooltip style={{ position: "fixed" }} id="ThemeColor">
                {isDark ? "Switch to light theme" : "Switch to dark theme"}
              </Tooltip>
            }
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon
                icon={isDark ? "sun" : "moon"}
                className="fs-0"
              />
            </div>
          </OverlayTrigger> */}
        </Nav.Link>
      </Nav.Item>
      {[
        ROLES_NAME.SUPER_ADMIN,
        ROLES_NAME.MAKER,
        ROLES_NAME.CHECKER,
        ROLES_NAME.PUBLISHER,
        ROLES_NAME.DOCTOR,
        ROLES_NAME.CLINIC_DOCTOR,
        ROLES_NAME.CONSULT_DOCTOR
      ].includes(getCurrentUserRole()) ? (
        <AppsMenu />
      ) : null}
      <ProductDetails />
      {/* <NotificationDropdown /> */}
      {(["doctor", "consult_doctor"].includes(currentUser) && !DOCTOR_BOOKING_FLAG) ? null : (
        <CreateTicketScreen
          customerData={isLeadDeatilsPage ? customerData : null}
        />
      )}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
